/** @format */

import React, { useState, useRef } from 'react';
import { PageContainer, FilterPod, TableComponents, TableItemActionsNew, Icons } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { Box, Grid } from '@mui/material';
import createToast from 'components/Toast/Toast';
import { useCopy , useCurrencyUnit } from 'hooks';
import InitFilters from '../../constants/InitFiltering';
import Services from '../../services/ServicesWithdrawRules';
import { useStyles } from './Style';
import axios from 'axios';
import { columns, generateData } from './Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const CusomterWithdraws = () => {
  // -- STATES --//
  const tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);

  const [filters, setFilters] = useState(InitFilters());
  const { copyItem } = useCopy();
  const [loadingLink, setLoadingLink] = useState(false);
  const [loadingId, setLoadingId] = useState(0);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'contentsWithdrawRulesPage',
      'reciveLinksWithdrawRulesBtn'

    ])
  // --HOOKS--//
  const classes = useStyles();
  const currencyText = useCurrencyUnit();

  // --HOOKS--//

  // --API REQUESTS--//
  const getList = async (query) => {
    try {
      setLoading(true);

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      setFilterParams({ params });

      const res = await Services.getWithdrawRules(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };
  const getActivationLink = async (rowData) => {
    if (!rowData?.id) return createToast('خطا', 'شناسه قانون برداشت مشخص نشده است!', 'danger');

    try {
      setLoadingId(rowData?.id);
      setLoadingLink(true);
      const res = await Services.getRuleLink(rowData?.id);

      if (res?.result) {
        copyItem(res?.result, 'لینک فعال‌سازی کپی شد!');
      } else {
      }
      setLoadingLink(false);
    } catch (error) {
      setLoadingLink(false);
    }
  };

  const hint =
    'در این قسمت می‌توانید لیست قوانین برداشتی که قابلیت فعال شدن برای مشتریانتان دارد را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست قوانین برداشت"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.WITHDRAWRULES_RULES_LIST}
      className={classes.root}
    >
      {(actionsList['contentsWithdrawRulesPage'] && currencyText) && (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          <TableComponents
            data={getList}
            columns={columns( currencyText)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getList(ps)
            }}
            actions={[
              ...((actionsList['reciveLinksWithdrawRulesBtn']) ? [
                (rowData) => ({
                  isFreeAction: true,
                  icon: () => (
                    <TableItemActionsNew
                      iconButton
                      startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                      title=""
                      disabled={loadingId === rowData?.id ? loadingLink : ''}
                      otherMenus={[
                        {
                          title: 'دریافت لینک فعال‌سازی ',
                          isShow: true,
                          disabled: loadingLink,
                          onClick: () => {
                            getActivationLink(rowData);
                          },

                        },
                      ]}
                    />
                  ),
                }),
              ] : [])
            ]}
          />
        </>
      )}
    </PageContainer>
  );
};

// See detail for every row

export default CusomterWithdraws;
